<div class="fpx-form-control">
    <div>
        <mat-checkbox [checked]="formControl.value == 1 ? true : false" (change)="onCheckBoxChange($event)" [labelPosition]="textPosition"
            [ngClass]="{'input-available': formControl.value}">
  
            <div class="content">
                {{ label }}
            </div>
        </mat-checkbox>
    </div>
  </div>
  